module.exports = __webpack_public_path__ + "img/SY.918b25a6.png";